import axios from 'axios'
import store from './store/index.js'

axios.interceptors.request.use((config) => {
    const token = store.getters.getAuthToken
    config.headers.authorization = `Bearer ${token}`
    return config
})

export default axios
